export { findCodeBlock, transformSliceToJoinAdjacentCodeBlocks, transformSingleLineCodeBlockToCodeMark } from '@atlaskit/editor-common/transforms';
export function getCursor(selection) {
  return selection.$cursor || undefined;
}
export function getAllCodeBlockNodesInDoc(state) {
  var codeBlockNodes = [];
  state.doc.descendants(function (node, pos) {
    if (node.type === state.schema.nodes.codeBlock) {
      codeBlockNodes.push({
        node: node,
        pos: pos
      });
      return false;
    }
    return true;
  });
  return codeBlockNodes;
}